import { z } from "zod";
import { TeamRoles } from "./team-roles.ts";

export const NotificationTypes = [
  "INVITE_RECEIVED",
  "TEAM_MEMBER_JOINED",
  "DFY_ORDER_DELIVERED",
] as const;

export const NotificationDisplayTypes = ["INLINE", "TOAST"] as const;

export const NotificationInvitePayloadDto = z.object({
  externalId: z.string(),
  email: z.string(),
  role: z.enum(TeamRoles),
  teamName: z.string().nullable(),
  teamExternalId: z.string(),
});

export const NotificationDfyOrderPayloadDto = z.object({
  externalId: z.string(),
  teamExternalId: z.string(),
});

export const NotificationDto = z.object({
  externalId: z.string(),
  type: z.enum(NotificationTypes),
  displayType: z.enum(NotificationDisplayTypes),
  createdAt: z.string(),
  seenAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
  invite: NotificationInvitePayloadDto.nullable(),
  dfyOrder: NotificationDfyOrderPayloadDto.nullable(),
  message: z.string().nullable(),
});

export const NotificationCursorDto = z.object({
  createdAt: z.string(),
  externalId: z.string(),
});

export const PagedNotificationsRequestDto = z.object({
  pageSize: z.number().nullable(),
  cursorCreatedAt: z.string().optional(),
  cursorExternalId: z.string().optional(),
});

export const PagedNotificationsResponseDto = z.object({
  items: z.array(NotificationDto),
  nextCursor: NotificationCursorDto.nullable(),
});

export const MarkAllNotificationsSeenResponseDto = z.object({
  ok: z.literal(true),
});

export type NotificationInvitePayloadDto = z.infer<
  typeof NotificationInvitePayloadDto
>;
export type NotificationDfyOrderPayloadDto = z.infer<
  typeof NotificationDfyOrderPayloadDto
>;
export type NotificationDto = z.infer<typeof NotificationDto>;
export type NotificationCursorDto = z.infer<typeof NotificationCursorDto>;
export type PagedNotificationsRequestDto = z.infer<
  typeof PagedNotificationsRequestDto
>;
export type PagedNotificationsResponseDto = z.infer<
  typeof PagedNotificationsResponseDto
>;
export type MarkAllNotificationsSeenResponseDto = z.infer<
  typeof MarkAllNotificationsSeenResponseDto
>;
export type NotificationType = (typeof NotificationTypes)[number];
export type NotificationDisplayType = (typeof NotificationDisplayTypes)[number];
